import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import {ChatContextProvider} from "./context/chatContext";
import HomePage from "./Pages/HomePage";
import ProfilePage from "./Pages/ProfilePage";
import SchoolsManagement from "./Pages/SchoolsManagement";
import NewLogin from "./Components/NewLogin";
import Layout from "./Layout";
import ErrorBoundary from "./Components/ErrorBoundary";
import {useEffect} from "react";
import superAdminAPI from "./services/superAdminAPI";
import AuditLogsPage from "./Pages/AuditLogsPage";

function App() {
    // Check authentication status when app loads
    useEffect(() => {
        const checkAuth = async () => {
            // Only attempt a token refresh if we have a token
            if (localStorage.getItem('accessToken')) {
                try {
                    // Test connection to see if token is valid
                    const test = await superAdminAPI.testConnection();
                    console.log("Backend connection status:", test);
                } catch (error) {
                    console.error("Authentication check failed:", error);
                    // If authentication fails, redirect to login
                    if (window.location.pathname !== '/') {
                        window.location.href = '/';
                    }
                }
            }
        };

        checkAuth();
    }, []);

    return (
        <ErrorBoundary>
            <ChatContextProvider>
                <Router>
                    <Routes>
                        <Route path="/" element={<NewLogin/>}/>
                        <Route path="/login" element={<Navigate to="/" replace/>}/>

                        <Route path="/dashboard" element={
                            <ProtectedRoute>
                                <HomePage/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/homepage" element={
                            <Navigate to="/dashboard" replace/>
                        }/>

                        <Route path="/schools" element={
                            <ProtectedRoute>
                                <SchoolsManagement/>
                            </ProtectedRoute>
                        }/>

                        <Route path="/profile" element={
                            <ProtectedRoute>
                                <ProfilePage/>
                            </ProtectedRoute>
                        }/>

                        {/* Placeholder routes for other super admin features */}
                        <Route path="/analytics" element={
                            <ProtectedRoute>
                                <Layout pageTitle="Analytics & Reports">
                                    <div className="p-8 text-center">
                                        <h2 className="text-2xl font-bold text-gray-800">Analytics & Reports</h2>
                                        <p className="text-gray-600 mt-2">Coming soon...</p>
                                    </div>
                                </Layout>
                            </ProtectedRoute>
                        }/>

                        <Route path="/superadmins" element={
                            <ProtectedRoute>
                                <Layout pageTitle="Super Admin Management">
                                    <div className="p-8 text-center">
                                        <h2 className="text-2xl font-bold text-gray-800">Super Admin Management</h2>
                                        <p className="text-gray-600 mt-2">Coming soon...</p>
                                    </div>
                                </Layout>
                            </ProtectedRoute>
                        }/>

                        <Route path="/audit-logs" element={
                            <ProtectedRoute>
                                <AuditLogsPage/>
                            </ProtectedRoute>
                        }/>

                        {/*<Route path="/security" element={*/}
                        {/*    <ProtectedRoute>*/}
                        {/*        <SecurityPage/>*/}
                        {/*    </ProtectedRoute>*/}
                        {/*}/>*/}

                        {/*<Route path="/settings" element={*/}
                        {/*    <ProtectedRoute>*/}
                        {/*        <SettingsPage/>*/}
                        {/*    </ProtectedRoute>*/}
                        {/*}/>*/}

                        {/* Catch-all route */}
                        <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
                    </Routes>
                </Router>
            </ChatContextProvider>
        </ErrorBoundary>
    );
}

export default App;